import { useEffect, useRef } from 'react';
import { LoginForm } from "wasp/client/auth";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { useAuth } from 'wasp/client/auth';
import { AuthPageLayout } from "./AuthPageLayout";
import useTranslation from "../client/hooks/useTranslation";
import { trackLogin } from '../client/utils/posthog';

export default function Login() {
  const t = useTranslation();
  const { data: user } = useAuth();
  const wasLoggedInOnMount = useRef<boolean | null>(null);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (wasLoggedInOnMount.current === null) {
      wasLoggedInOnMount.current = !!user;
    }
    if (user && wasLoggedInOnMount.current === false && !hasTracked.current) {
      hasTracked.current = true;
      trackLogin();
    }
  }, [user]);

  return (
    <AuthPageLayout>
      <LoginForm appearance={{ colors: { brand: 'hsl(var(--primary))', brandAccent: 'hsl(var(--primary))', submitButtonText: '#ffffff' } }} />
      <br />
      <span className="text-sm font-medium text-gray-900">
        {t.auth.noAccount}{" "}
        <WaspRouterLink to={routes.SignupRoute.to} className="underline">
          {t.auth.goToSignup}
        </WaspRouterLink>
      </span>
      <br />
      <span className="text-sm font-medium text-gray-900">
        {t.auth.forgotPasswordQuestion}{" "}
        <WaspRouterLink
          to={routes.RequestPasswordResetRoute.to}
          className="underline"
        >
          {t.auth.resetIt}
        </WaspRouterLink>
      </span>
    </AuthPageLayout>
  );
}
